module.exports = __webpack_public_path__ + "static/media/ico_duplicate.e540b8a0.svg";